import React from 'react'
import { Card, Typography, IconButton, CardMedia, Box } from '@mui/material'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import { formatCommonAmount } from '../../../util/formatAmount'
import styles from '../../settingsTabs/venderSettingTabs.module.scss'
import PackageStyles from './package.module.scss'

const PackagesListView = ({
	cardStyle,
	vendorId,
	packages = [],
	showActions = false,
	onAddPackage,
	onOpenMenu,
}) => {
	return (
		<Card
			sx={cardStyle}
			variant="outlined"
			className={`${styles.vendorCardBusinessInfo} ${styles.serviceInfo}`}
		>
			{showActions && vendorId && onAddPackage && (
				<div className={styles.infoHeader}>
					<Typography
						variant="h5"
						gutterBottom
						sx={{ fontWeight: 'bold' }}
					>
						Packages ({packages.length})
					</Typography>

					<ButtonCustom
						variant="outlined"
						size="md"
						onClick={onAddPackage}
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: '4px',
							textTransform: 'none',
							borderRadius: '8px',
							padding: '6px 12px',
						}}
					>
						<span style={{ fontSize: '16px' }}>+</span>
						Add Packages
					</ButtonCustom>
				</div>
			)}
			<Box className={PackageStyles.packagesContainer} style={showActions ? {} : {
				maxHeight: '300px',
				overflow: 'auto',
			}}>
				{packages.length > 0 ? (
					packages.map((pkg, index) => (
						<Box
							key={pkg._id || index}
							className={PackageStyles.packageCard}
						>
							<Box
								sx={{
									display: 'flex',
									gap: 2,
								}}
							>
								<CardMedia
									component="img"
									sx={{
										width: '72px',
										height: '72px',
										objectFit: 'cover',
										borderRadius: '8px',
									}}
									image={
										pkg.image || '/images/placeholder.png'
									}
									alt={pkg.name}
								/>
								<Box sx={{ flex: 1 }}>
									<Box className={PackageStyles.packageName}>
										<Typography variant="h6">
											{pkg.name || 'Package Name'}
										</Typography>
										{showActions &&
											vendorId &&
											onOpenMenu && (
												<IconButton
													onClick={(e) =>
														onOpenMenu(e, index)
													}
													disableRipple
													sx={{
														padding: '0px',
														'&:hover': {
															backgroundColor:
																'transparent',
														},
													}}
												>
													<img
														src="/images/more.svg"
														alt="options"
														style={{
															width: '20px',
															height: '20px',
														}}
													/>
												</IconButton>
											)}
									</Box>
									<Typography
										variant="body2"
										className={
											PackageStyles.packageDescription
										}
									>
										{pkg.description ||
											'Included in this package details'}
									</Typography>
									<Box>
										<Typography
											variant="h6"
											className={
												PackageStyles.packagePrice
											}
										>
											{formatCommonAmount(pkg.price)}
										</Typography>
									</Box>
								</Box>
							</Box>

							{pkg.addOnsIds && pkg.addOnsIds.length > 0 && (
								<Box className={PackageStyles.packageAddons}>
									<Typography
										variant="body2"
										className={
											PackageStyles.packageAddonsTitle
										}
									>
										Available Add-ons (
										{pkg.addOnsIds.length})
									</Typography>
									<Box
										className={
											PackageStyles.packageAddonsList
										}
									>
										{pkg.addOnsIds.map(
											(addon, addonIndex) => (
												<Box
													key={
														addon?._id || addonIndex
													}
													className={
														PackageStyles.packageAddonsItem
													}
												>
													<div
														style={{
															display: 'flex',
															alignItems:
																'center',
															gap: '12px',
														}}
													>
														<CardMedia
															component="img"
															sx={{
																width: '42px',
																height: '42px',
																objectFit:
																	'cover',
																borderRadius:
																	'8px',
																flexShrink: 0,
															}}
															image={
																addon?.image ||
																'/images/placeholder.png'
															}
															alt={addon.name}
														/>
														<div
															className={
																PackageStyles.packageAddonsItemNamemain
															}
														>
															<Typography
																variant="body2"
																className={
																	PackageStyles.packageAddonsItemName
																}
															>
																{addon?.name ||
																	'--'}
															</Typography>
															<Typography
																variant="body2"
																className={
																	PackageStyles.packageAddonsItemPrice
																}
															>
																{formatCommonAmount(
																	addon?.price
																)}
															</Typography>
														</div>
													</div>
													{addon?.isThisAddOnIsRequired && (
														<Box
															className={
																PackageStyles.packageAddonsItemRequired
															}
														>
															Required
														</Box>
													)}
												</Box>
											)
										)}
									</Box>
								</Box>
							)}
						</Box>
					))
				) : (
					<Typography
						variant="body2"
						sx={{
							color: '#999999',
							textAlign: 'center',
							padding: '20px',
						}}
					>
						No packages available
					</Typography>
				)}
			</Box>
		</Card>
	)
}

export default PackagesListView
